import { ToggleButtonListControl } from 'ia-react-core';
import { FormSection } from 'omni-package-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledP } from './CorrespondenceSection.styles';

export interface CorrespondenceSectionProps {
}

const CorrespondenceSection: FC<CorrespondenceSectionProps> = () => {
  const { t } = useTranslation('PersonalInformationsFormPage');

  return (
    <FormSection pb={36} title={t('correspondence.title')}>
      <StyledP>{t('correspondence.label')}</StyledP>
      <ToggleButtonListControl
        required
        name="correspondence.language"
        options={[
          { label: t('correspondence.french'), value: 'fr' },
          { label: t('correspondence.english'), value: 'en' },
        ]}
      />
    </FormSection>
  );
};

export default (CorrespondenceSection);
